(function () {
  /**
   * Fetches the latest cart sidebar HTML using the Section Rendering API.
   * Uses the window.Shopify.routes.root to build a locale‑aware URL.
   */
  function fetchCartSection() {
    var sectionId = "cart-sidebar";
    var url = window.Shopify.routes.root + "?sections=" + sectionId;
    fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data[sectionId]) {
          // Replace the current cart sidebar with the new HTML.
          document.getElementById("cart-sidebar-wrapper").innerHTML =
            data[sectionId];
          // Re-bind any events as necessary.
          console.log("Cart section updated via Section Rendering API.");
          checkCartItemQuantities();
        } else {
          console.error("Cart section not found in API response.");
        }
      })
      .catch(function (error) {
        console.error("Error fetching cart section:", error);
      });
  }

  // ====================================================
  // Module: Quantity Check
  // ====================================================
  /**
   * Checks each cart item's quantity and disables the minus button if quantity is 1.
   */
  function checkCartItemQuantities() {
    var cartItems = document.querySelectorAll("#cart-sidebar [data-cartitem]");
    Array.prototype.forEach.call(cartItems, function (cartItemEl) {
      var input = cartItemEl.querySelector("[data-quantity-input]");
      var minusWrapper = cartItemEl.querySelector(
        "[data-button-wrapper-minus]"
      );
      if (input && minusWrapper) {
        var quantity = parseInt(input.value, 10);
        if (quantity <= 1) {
          // Disable minus functionality visually.
          minusWrapper.classList.add(
            "quantity-selector__button-wrapper--disabled"
          );
          // Optionally, disable the button itself.
          var minusBtn = cartItemEl.querySelector("[data-quantity-minus]");
          if (minusBtn) {
            minusBtn.disabled = true;
          }
        } else {
          minusWrapper.classList.remove(
            "quantity-selector__button-wrapper--disabled"
          );
          var minusBtn = cartItemEl.querySelector("[data-quantity-minus]");
          if (minusBtn) {
            minusBtn.disabled = false;
          }
        }
      }
    });
  }

  function openSidebar() {
    var cartSidebar = document.querySelector("#cart-sidebar");
    if (cartSidebar) {
      cartSidebar.style.transform = "none"; // Show sidebar.
      document.body.classList.add("cart-sidebar-show");
    }
  }

  // Listen for a custom event "cart:updated" and refresh the section with a delay.
  window.addEventListener("cart:updated", function () {
    console.log("Received cart:updated event. Refreshing cart section...");
    setTimeout(function () {
      fetchCartSection();
    }, 500); // 500ms delay before fetching
  });

  window.addEventListener("sidebar:open", function () {
    console.log("Received sidebar:open. Opening sidebar cart...");
    openSidebar()
  });

  document.addEventListener("DOMContentLoaded", function () {
    // Cache elements that are unlikely to change.
    var cartButton = document.querySelector(".site-header-cart--button");
    var backgroundOverlay = document.querySelector(".background-overlay");
    var cartSidebarWrapper = document.getElementById("cart-sidebar-wrapper");
    checkCartItemQuantities();

    // Open sidebar when the cart button is clicked.
    if (cartButton) {
      cartButton.addEventListener("click", function (event) {
        event.preventDefault();
        openSidebar();
      });
    }

    // Use event delegation on the cart sidebar wrapper for clicks.
    if (cartSidebarWrapper) {
      cartSidebarWrapper.addEventListener("click", function (event) {
        // Handle remove button clicks.
        var removeBtn = event.target.closest("[data-cartitem-remove]");
        if (removeBtn) {
          event.preventDefault();
          var cartItemEl = removeBtn.closest("[data-cartitem]");
          if (!cartItemEl) return;
          var variantId = cartItemEl.getAttribute("data-cartitem-id");

          // Remove item by setting its quantity to 0.
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 0 }),
          })
            .then(function (response) {
              if (!response.ok) {
                return Promise.reject(response);
              }
              return response.json();
            })
            .then(function (data) {
              var cartUpdatedEvent = new CustomEvent("cart:updated", {
                detail: data,
              });
              window.dispatchEvent(cartUpdatedEvent);
              console.log(
                "Remove button clicked. Item removed successfully:",
                data
              );
            })
            .catch(function (error) {
              console.error("Error removing cart item:", error);
              alert(error.message || "Unable to remove item.");
            });
          return; // Exit if remove button was handled.
        }

        // Handle plus button clicks.
        var plusBtn = event.target.closest("[data-quantity-plus]");
        if (plusBtn) {
          event.preventDefault();
          var cartItemEl = plusBtn.closest("[data-cartitem]");
          if (!cartItemEl) return;
          var input = cartItemEl.querySelector("[data-quantity-input]");
          var currentQuantity = parseInt(input.value, 10);
          var newQuantity = currentQuantity + 1;
          var variantId = cartItemEl.getAttribute("data-cartitem-id");

          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: newQuantity }),
          })
            .then(function (response) {
              if (!response.ok) {
                return Promise.reject(response);
              }
              return response.json();
            })
            .then(function (data) {
              input.value = newQuantity;
              var cartUpdatedEvent = new CustomEvent("cart:updated", {
                detail: data,
              });
              window.dispatchEvent(cartUpdatedEvent);
              console.log(
                "Plus button clicked. Cart updated successfully:",
                data
              );
            })
            .catch(function (error) {
              input.value = currentQuantity;
              plusBtn.disabled = true;
              plusBtn.classList.add(
                "quantity-selector__button-wrapper--disabled"
              );
              plusBtn.style.cursor = "not-allowed";
              console.error(
                "Error updating cart. Plus button disabled.",
                error
              );
            });
          return; // Exit if plus button was handled.
        }

        // ----- Handle Close Button -----
        var closeBtn = event.target.closest("[data-close-cart-sidebar]");
        if (closeBtn) {
          event.preventDefault();
          var cartSidebar = document.querySelector("#cart-sidebar");
          if (cartSidebar) {
            cartSidebar.style.transform = "translate3d(calc(102% + 40px),0,0)";
          }
          document.body.classList.remove("cart-sidebar-show");
          return; // Exit early if close button handled.
        }

        // Handle minus button clicks.
        var minusBtn = event.target.closest("[data-quantity-minus]");
        if (minusBtn) {
          event.preventDefault();
          var cartItemEl = minusBtn.closest("[data-cartitem]");
          if (!cartItemEl) return;
          var input = cartItemEl.querySelector("[data-quantity-input]");
          var currentQuantity = parseInt(input.value, 10);
          if (currentQuantity > 1) {
            var newQuantity = currentQuantity - 1;
            var variantId = cartItemEl.getAttribute("data-cartitem-id");

            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: variantId, quantity: newQuantity }),
            })
              .then(function (response) {
                if (!response.ok) {
                  return Promise.reject(response);
                }
                return response.json();
              })
              .then(function (data) {
                input.value = newQuantity;
                var cartUpdatedEvent = new CustomEvent("cart:updated", {
                  detail: data,
                });
                window.dispatchEvent(cartUpdatedEvent);
                console.log(
                  "Minus button clicked. Cart updated successfully:",
                  data
                );
              })
              .catch(function (error) {
                input.value = currentQuantity;
                minusBtn.disabled = true;
                minusBtn.classList.add(
                  "quantity-selector__button-wrapper--disabled"
                );
                minusBtn.style.cursor = "not-allowed";
                console.error(
                  "Error updating cart. Minus button disabled.",
                  error
                );
                alert(error.message || "Unable to update quantity.");
              });
          }
          return;
        }
      });
    }

    // Use event delegation on the document body to handle background overlay clicks.
    document.body.addEventListener("click", function (event) {
      var overlay = event.target.closest(".background-overlay");
      if (overlay) {
        var cartSidebar = document.querySelector("#cart-sidebar");
        if (cartSidebar) {
          cartSidebar.style.transform = "translate3d(calc(102% + 40px),0,0)";
        }
        document.body.classList.remove("cart-sidebar-show");
      }
    });
  });
})();
